<script setup lang="ts">
import IconCart from '~icons/mdi/cart'
import IconHelp from '~icons/mdi/help-circle-outline'

const userStore = useUserStore()
const localePath = useLocalePath()
const display = useDisplay()
const { helpUrl } = useCountryConfig()
// cart-store relays on the user-store, therefore, we need to wait for the user-store to be initialized before using the cart-store
const cartStore = useCart()
</script>

<template>
  <v-sheet v-if="display.width.value === 0" class="app-bar" />

  <v-app-bar
    flat
    color="red-400"
    class="app-bar"
    :height="display.width.value !== 0 && display.mdAndUp.value ? '80' : '120'"
  >
    <NuxtImg class="app-bar__bgImg img-left" src="/images/bird.svg" width="188" />
    <NuxtImg class="app-bar__bgImg img-right" src="/images/bird.svg" width="148" />

    <v-container class="container-fluid-mobile">
      <v-row no-gutters align="center">
        <v-col
          cols="6"
          sm="6"
          md="2"
          lg="2"
        >
          <VmzAppBarLogo />
        </v-col>

        <v-col
          cols="12"
          sm="12"
          md="7"
          lg="7"
          xl="8"
          order="12"
          order-sm="12"
          order-md="2"
          test-id="search-wrapper"
          class="d-flex justify-center align-center py-1"
        >
          <LayoutSearch v-if="userStore.isAuthenticated" />
        </v-col>

        <v-col
          v-if="userStore.isAuthenticated"
          cols="6"
          sm="6"
          md="3"
          lg="3"
          xl="2"
          order="6"
          order-sm="6"
          order-md="10"
          class="d-flex justify-end"
        >
          <div class="d-flex align-center">
            <!-- Cart Button - Desktop Only -->
            <div v-if="display.mdAndUp.value">
              <v-badge
                v-if="cartStore.totalAmount"
                :max="99"
                :content="cartStore.totalAmount"
                color="black-800"
                offset-x="8"
                offset-y="8"
              >
                <v-btn
                  color="white"
                  :to="localePath('/cart')"
                  size="large"
                  data-nav-id="header_cart"
                >
                  <span v-if="display.lgAndUp.value" class="text-white mr-1 text-body-2">{{ $t('cart.title') }}</span>
                  <v-icon :icon="IconCart" />
                </v-btn>
              </v-badge>
              <v-btn
                v-else
                color="white"
                :to="localePath('/cart')"
                size="large"
                data-nav-id="header_cart"
              >
                <span class="text-white mr-1 text-body-2">{{ $t('cart.title') }}</span>
                <v-icon :icon="IconCart" />
              </v-btn>
            </div>

            <!-- Common Actions - Desktop & Mobile -->
            <div class="d-flex align-center" :class="display.mdAndUp.value ? 'ml-4' : ''">
              <LangSwitcher />
              <v-btn
                v-if="helpUrl"
                variant="text"
                size="small"
                class="ml-2"
                color="white"
                target="_blank"
                :href="helpUrl"
                icon
                data-nav-id="header_help"
                style="letter-spacing: 0px; opacity: 1"
              >
                <v-icon size="24" :icon="IconHelp" />
              </v-btn>
              <div v-if="userStore.data" class="ml-2">
                <LayoutAccountMenu />
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<style lang="scss">
.app-bar {
  height: 80px !important;
  > div {
    height: 80px !important;
  }
  @media (max-width: 960px) {
    height: 120px !important;
    > div {
      height: 120px !important;
    }
  }
  &__bgImg {
    position: absolute;
    z-index: -1;
    &.img-left {
      left: -50px;
      top: -50px;
    }
    &.img-right {
      right: 50px;
      top: 50px;
    }
  }
  @media (max-width: 600px) {
    &__bgImg {
      display: none !important;
    }
  }
   &__search-wrapper {
    width: 720px;
  }
}
.container-fluid-mobile {
  @media (max-width: 1280px) {
    max-width: 100%;
  }
}
</style>
